import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { documentsApi } from '../api/index.js';
import { useAuth } from '../hooks/useAuth.js';

export function DocumentsPage() {
  const { user } = useAuth();
  const [status, setStatus] = useState('');
  const [source, setSource] = useState('');

  const params: Record<string, string> = {};
  if (status) params['status'] = status;
  if (source) params['source'] = source;

  const { data, isLoading } = useQuery({
    queryKey: ['documents', status, source],
    queryFn: () => documentsApi.list(Object.keys(params).length ? params : undefined),
  });

  const docs = data?.documents ?? [];
  const total = data?.total ?? 0;

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>Documents</h1>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={{ maxWidth: '160px' }}>
          <option value="">All statuses</option>
          <option value="completed">Completed</option>
          <option value="pending">Pending</option>
          <option value="failed">Failed</option>
        </select>
        <select value={source} onChange={(e) => setSource(e.target.value)} style={{ maxWidth: '160px' }}>
          <option value="">All sources</option>
          <option value="web">Web</option>
          <option value="mcp">MCP</option>
        </select>
        {user?.role === 'admin' && (
          <span style={{ fontSize: '.875rem', color: 'var(--color-text-muted)', alignSelf: 'center' }}>
            Showing all users' documents
          </span>
        )}
      </div>

      {isLoading ? (
        <p>Loading…</p>
      ) : (
        <div className="card">
          <div style={{ marginBottom: '.75rem', fontSize: '.875rem', color: 'var(--color-text-muted)' }}>
            {total} document{total !== 1 ? 's' : ''} total
          </div>
          {docs.length === 0 ? (
            <p style={{ color: 'var(--color-text-muted)' }}>No documents found.</p>
          ) : (
            <table>
              <thead>
                <tr><th>File</th><th>Source</th><th>Status</th><th>Size</th><th>Created</th></tr>
              </thead>
              <tbody>
                {docs.map((d) => (
                  <tr key={d.id}>
                    <td><Link to={`/documents/${d.id}`}>{d.fileName}</Link></td>
                    <td><span className={`badge ${d.source === 'mcp' ? 'badge-green' : 'badge-gray'}`}>{d.source}</span></td>
                    <td>
                      <span className={`badge ${d.status === 'completed' ? 'badge-green' : d.status === 'failed' ? 'badge-red' : 'badge-yellow'}`}>
                        {d.status}
                      </span>
                    </td>
                    <td style={{ color: 'var(--color-text-muted)' }}>
                      {d.fileSize ? `${(d.fileSize / 1024).toFixed(1)} KB` : '–'}
                    </td>
                    <td style={{ color: 'var(--color-text-muted)' }}>
                      {new Date(d.createdAt).toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
